// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__1u2gA","title":"AfterImages90_title__1hOoZ","images":"AfterImages90_images__3RHR2"};